import { useState, useEffect } from 'react';

/**
 * Subscribes to a media query and returns whether it matches.
 * Useful for responsive behavior (e.g. isMobile, isTablet).
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    const mql = window.matchMedia(query);
    const handler = () => setMatches(mql.matches);
    handler();
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, [query]);

  return matches;
}

/** Breakpoint matching Tailwind sm (640px). Use for mobile-specific UI. */
export const MOBILE_BREAKPOINT_PX = 640;
export const MOBILE_BREAKPOINT = `(max-width: ${MOBILE_BREAKPOINT_PX}px)`;

/**
 * Short viewport (height): compact compose field labels (À : / Objet :).
 * ~1080p at 125% zoom ≈ 864px CSS height → short.
 */
export const SHORT_VIEWPORT_MAX_PX = 900;
export const SHORT_VIEWPORT = `(max-height: ${SHORT_VIEWPORT_MAX_PX}px)`;
